import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { loginUser } from '../services/api';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    setError('');
    if (!form.email || !form.password) return setError('Rellena todos los campos');
    setLoading(true);
    try {
      const res = await loginUser(form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      const redirect = searchParams.get('redirect');
      if (res.data.user.role === 'admin') navigate('/admin');
      else if (res.data.user.role === 'portero') navigate('/escanear');
      else if (redirect) navigate(redirect);
      else navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: isMobile ? '2rem 1rem' : '4rem 2rem' }}>
        <div style={{ width: '100%', maxWidth: '420px' }}>
          <h1 style={{ color: colors.text, fontSize: isMobile ? '1.6rem' : '1.8rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Iniciar sesión</h1>
          <p style={{ color: colors.textSecondary, fontSize: '0.9rem', marginBottom: '2rem' }}>Bienvenido de nuevo a Galiticket</p>
          {error && <div style={{ backgroundColor: '#ff444422', border: '1px solid #ff4444', color: '#ff4444', padding: '0.8rem 1rem', borderRadius: '8px', marginBottom: '1.5rem', fontSize: '0.85rem' }}>{error}</div>}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Email</label>
            <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.8rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name="email" type="email" placeholder="tu@email.com" value={form.email} onChange={handleChange} />
          </div>
          <div style={{ marginBottom: '0.5rem' }}>
            <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Contraseña</label>
            <div style={{ position: 'relative' }}>
              <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.8rem 3rem 0.8rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name="password" type={showPassword ? 'text' : 'password'} placeholder="••••••••" value={form.password} onChange={handleChange} />
              <button type="button" onClick={() => setShowPassword(v => !v)} style={{ position: 'absolute', right: '0.8rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: colors.textSecondary, display: 'flex', alignItems: 'center', padding: 0 }}>
                {showPassword ? <VisibilityOffIcon style={{ fontSize: 20 }} /> : <VisibilityIcon style={{ fontSize: 20 }} />}
              </button>
            </div>
          </div>
          <p style={{ textAlign: 'right', marginBottom: '1.5rem' }}>
            <Link to="/forgot-password" style={{ color: colors.textSecondary, textDecoration: 'none', fontSize: '0.82rem' }}>¿Olvidaste tu contraseña?</Link>
          </p>
          <button style={{ backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.9rem', borderRadius: isMobile ? '4px' : '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem', width: '100%', textTransform: isMobile ? 'uppercase' : 'none', letterSpacing: isMobile ? '0.05em' : 'normal' }} onClick={handleSubmit} disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
          <p style={{ color: colors.textSecondary, fontSize: '0.9rem', textAlign: 'center', marginTop: '1.5rem' }}>
            ¿No tienes cuenta? <Link to="/register" style={{ color: colors.accent, textDecoration: 'none', fontWeight: 'bold' }}>Regístrate</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;